// Status of the Google-auth flow driven by useGoogleAuth / GoogleAuthButton.
// IDLE is the plain "Continue with Google" button; the other values are the panels it
// replaces the button with while it resolves what is still missing to finish signing in.
export enum GoogleAuthStatus {
	IDLE = "idle",
	LOADING = "loading",
	PENDING_PROFILE = "pendingProfile",
	PENDING_LINK = "pendingLink"
}
